<template>
  <div id="recordList" class="hub-grey">
    <div class="list-top">
      <h1>Record of Participation</h1>
    </div>
    <ul class="record-list">
      <li class="list-head">
        <div class="col-program">Module Name</div>
        <div class="col-theme">Theme Name</div>
        <div class="col-host">Facilitator</div>
        <div class="col-date">Date</div>
        <div class="col-time">Start Time</div>
        <div class="col-time">End Time</div>
      </li>
      <li v-for="record in recordList" :key="record.id" class="list-row">
        <div class="col-program">
          <span>Module: </span><span>{{ record.moduleName }}</span>
        </div>
        <div class="col-theme">
          <span>Theme: </span><span>{{ record.themeName }}</span>
        </div>
        <div class="col-host">
          <span>Facilitator: </span><span>{{ record.hostName }}</span>
        </div>
        <div class="col-date">
          <span>Date: </span><span>{{ $filters.simpleDate(record.endTime) }}</span>
        </div>
        <div class="col-time">
          <span>Start: </span><span>{{ $filters.simpleTime(record.startTime) }}</span>
        </div>
        <div class="col-time">
          <span>End: </span><span>{{ $filters.simpleTime(record.endTime) }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      recordList: [],
    };
  },

  methods: {
    async getRecordList() {
      const data = await this.$api.get(`/records/client/${this.currentClient.id}`);
      this.recordList = data.records;
    },
  },

  computed: {
    currentClient() {
      return this.$store.getters.HUBSettings.currentClient;
    },
  },

  watch: {
    'currentClient.id': {
      handler() {
        this.getRecordList();
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
#recordList {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  padding: 3em 0;
}

.list-top {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.list-top > h1 {
  margin-bottom: 0;
}

.record-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, 90%);
  justify-content: space-evenly;

  margin-top: 3em;
  width: 100%;
}
.list-head {
  display: none;
}
.list-row {
  display: grid;
  row-gap: 0.5em;
  padding: 1.5em 0.5em;
  border-bottom: 1px solid #a7a9ac;
}
.list-row:nth-child(2) {
  border-top: 1px solid #a7a9ac;
}

.list-row > div {
  display: flex;
  justify-content: space-between;
}
.list-row > div > span:first-child {
  width: 40%;
  font-weight: 700;
}
.list-row > div > span:nth-child(2) {
  text-align: right;
}

/** Larger devices */
@media only screen and (min-width: 601px) and (min-height: 601px) {
  .list-head {
    display: grid;
    grid-template-areas: 'a b c d e f';
    grid-template-columns: 23% 18% 18% 14% 11% 11%;
    justify-content: space-between;
    align-items: center;

    padding: 0 0.5em 0.5em;
    border-bottom: 1px solid #a7a9ac;
  }
  .list-row {
    grid-template-areas: 'a b c d e f';
    grid-template-columns: 23% 18% 18% 14% 11% 11%;
    justify-content: space-between;
  }
  .list-row:nth-child(2) {
    border-top: 0 none;
  }

  .list-row > div > span:nth-child(1) {
    display: none;
  }
  .list-row > div > span:nth-child(2) {
    text-align: left;
  }

  .col-program {
    margin-right: 10%;
  }
}
</style>
